import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useShopifyCookies } from '@shopify/hydrogen-react';
import { SHOPIFY_COOKIE_DOMAIN, sendShopifyPageView } from '../utils/shopifyAnalytics';

/**
 * Counts funnel visits in Shopify Analytics. Shopify's visitor cookies are set on the
 * parent domain, so the visit here and the checkout on shop.gritvuegear.com are
 * recognized as the same visitor. Renders nothing.
 */
export function ShopifyAnalytics() {
  const {
    pathname
  } = useLocation();
  useShopifyCookies({
    hasUserConsent: true,
    domain: SHOPIFY_COOKIE_DOMAIN
  });
  useEffect(() => {
    void sendShopifyPageView(pathname);
  }, [pathname]);
  return null;
}